// User action types
enum UserActionTypes {
	CREATE_USER = "CREATE_USER",
	GET_ALL_USERS = "GET_ALL_USERS",
	GET_USER = "GET_USER",
	REFRESH_TOKEN = "REFRESH_TOKEN",
	UPDATE_USER = "UPDATE_USER",
	ADMIN_UPDATE_USER = "ADMIN_UPDATE_USER",
	DELETE_USER = "DELETE_USER",
	LOGIN_USER = "LOGIN_USER",
	SET_USER_ID = "SET_USER_ID",
}

export default UserActionTypes;
